import PropTypes from 'prop-types';
import Image from 'next/image';
import clsx from 'clsx';

const defaultProps = {
  className: null,
};

const propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default function RemoteImage({
  src,
  alt,
  className,
  ...rest
}) {
  return (
    <Image
      src={src}
      alt={alt}
      className={clsx('block max-w-full h-auto', className)}
      {...rest}
    />
  );
}

RemoteImage.defaultProps = defaultProps;
RemoteImage.propTypes = propTypes;
